// extracted by mini-css-extract-plugin
export var expandButton = "expand-button-module--expandButton--4V1eY";
export var expandButtonLight = "expand-button-module--expandButtonLight--ZarRB";
export var expandButtonPosition = "expand-button-module--expandButtonPosition--SsdfY";